import React from 'react';
import { ChevronRightIcon, StarIcon, CheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-[#0b0b0b] flex flex-col justify-center overflow-hidden pt-10 pb-10 md:pt-14 md:pb-14" data-id="element-136">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#c9a24a]/8 via-[#0b0b0b] to-[#0b0b0b] pointer-events-none" data-id="element-137"></div>
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-5 pointer-events-none" data-id="element-138"></div>

      {/* Urgency Bar */}
      <div className="absolute top-0 left-0 w-full bg-[#141418] border-b border-white/5 py-1.5 z-50 overflow-hidden" data-id="element-139">
        <div className="flex whitespace-nowrap animate-marquee" data-id="element-140">
          {[...Array(3)].map((_, i) => <span key={i} className="inline-flex items-center gap-6 mx-6 text-[#c9a24a]/70 text-[9px] md:text-xs font-semibold uppercase tracking-widest" data-id="element-141">
              <span data-id="element-142">🔥 60% OFF por tiempo limitado</span>
              <span className="text-white/20" data-id="element-143">•</span>
              <span data-id="element-144">Precio de lanzamiento activo</span>
              <span className="text-white/20" data-id="element-145">•</span>
              <span data-id="element-146">Acceso inmediato</span>
              <span className="text-white/20" data-id="element-147">•</span>
              <span data-id="element-148">Cupos limitados</span>
              <span className="text-white/20" data-id="element-149">•</span>
            </span>)}
        </div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center mt-4 md:mt-6" data-id="element-150">
        {/* Pre-headline */}
        <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-3 py-1.5 md:px-4 md:py-2 mb-6 md:mb-8 backdrop-blur-sm" data-id="element-151">
          <div className="flex -space-x-2" data-id="element-152">
            {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-3 h-3 md:w-4 md:h-4 text-[#c9a24a] fill-[#c9a24a]" data-id="element-153" />)}
          </div>
          <span className="text-gray-300 text-[10px] md:text-sm font-semibold" data-id="element-154">
            +2.500 barberos ya están mejorando
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-3xl md:text-6xl lg:text-7xl font-black text-white leading-[1.1] mb-6 md:mb-8 tracking-tight" data-id="element-155">
          Si sentís que tus cortes no terminan de cerrar…{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c9a24a] to-[#b8913f]" data-id="element-156">
            no es falta de práctica, es falta de método.
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-base md:text-2xl text-gray-300 font-medium leading-relaxed mb-6 md:mb-8 max-w-3xl mx-auto" data-id="element-157">
          Aprendé a hacer fades limpios, trabajar con seguridad y dejar de
          improvisar en cada cliente.
        </p>

        {/* Support Line */}
        <div className="bg-[#141418]/80 border border-white/10 rounded-xl md:rounded-2xl p-4 md:p-6 mb-8 md:mb-12 max-w-2xl mx-auto backdrop-blur-sm" data-id="element-158">
          <p className="text-sm md:text-lg text-gray-400 font-semibold leading-snug" data-id="element-159">
            Convertí la barbería en un oficio real con un sistema paso a paso
            pensado para resultados.
          </p>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-4" data-id="element-160">
          <a href="#pricing" className="cta-primary inline-flex items-center justify-center gap-2 w-full md:w-auto px-6 md:px-12 py-4 md:py-5 rounded-xl md:rounded-2xl text-white font-black text-sm md:text-xl uppercase tracking-wide" data-id="element-161">
            QUIERO MEJORAR MIS CORTES AHORA
            <ChevronRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-162" />
          </a>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 text-gray-500 text-[10px] md:text-xs font-medium" data-id="element-163">
            <span className="flex items-center gap-1" data-id="element-164">
              <CheckIcon className="w-3 h-3 md:w-4 md:h-4 text-[#c9a24a]" data-id="element-165" />
              Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-166">
              <CheckIcon className="w-3 h-3 md:w-4 md:h-4 text-[#c9a24a]" data-id="element-167" />
              100% online
            </span>
            <span className="flex items-center gap-1" data-id="element-168">
              <CheckIcon className="w-3 h-3 md:w-4 md:h-4 text-[#c9a24a]" data-id="element-169" />
              Pago seguro
            </span>
          </div>
        </div>
      </div>
    </section>;
}